export const URLS = {
  document: '/editor',
  documents: '/documents',
  gettingStarted: '/getting-started',
  documentPreview: '/document',
  preview: '/preview',
  editDocument: function (documentId: string) {
    return `${this.document}/${documentId}`;
  },
  editByContentId: function (contentId: string) {
    return `${this.document}/document/${contentId}`;
  },
  previewDocument: function (documentId: string) {
    return `${this.preview}/${documentId}`;
  },
  previewByContentId: function (contentId: string) {
    return `${this.documentPreview}/${contentId}`;
  },
  documentInsights: function (documentId: string) {
    return `${this.documents}?insightsDocId=${documentId}`;
  },
  documentsUploadPdf: function () {
    return `${this.documents}?uploadPdf=true`;
  },
  settings: '/settings',
  ssoConfiguration: '/settings/sso',
  pipeline: '/pipeline',
  cinderEditDocument: function (documentId: string) {
    return `/proposal/edit/${documentId}`;
  },
  library: '/library',
  chooseTemplate: '/choose-template',
  templateEdit: function (templateId: string) {
    return `/editor/template/${templateId}`;
  },
  templatePreview: function (contentId: string) {
    return `/template/${contentId}`;
  },
  errorForbiddenAccess: '/errors/document-no-access',
};

export const supportUrls = {
  base: 'https://support.proposify.com/',
  helpCenter: 'https://links.proposify.com/support/knowledge-base',
  customFields: '/hc/en-us/articles/37888416495515-Custom-fields',
  automaticReminder: '/hc/en-us/articles/37745974059547',
  gong: '/hc/en-us/articles/4849133988763-Gong',
  get(url: string) {
    return `${supportUrls.base}${url}`;
  },
} as const;
